<template>
    <div>
        <button type="submit" class="rounded-full btn btn-line font-semibold px-6" @click="attemptArchive">Archive</button>
    </div>
</template>

<script>
import { delay } from '../../utils';

export default {
    props: {
        projectId: {
            type: String,
            required: true
        }
    },

    methods: {
        async attemptArchive() {
            if (confirm('Are you sure you want to archive this job?')) {
                await axios.post(`/api/projects/${this.projectId}/archive`);

                NProgress.inc();
                await delay(1000);
                NProgress.done();
                window.location.reload();
            }
            /*
            this.$confirm('Are you sure you want to archive this job?', this.handleArchive, {
                confirm: {
                    yes: 'Archive Job'
                },
                onSuccess: this.onSuccess
            });
            */
        },

        async handleArchive() {
            await axios.post(`/api/projects/${this.projectId}/archive`);
        },

        async onSuccess() {
            NProgress.inc();
            await delay(1000);
            NProgress.done();
            window.location.reload();
        }
    }
};
</script>
